import * as React from "react";
import useParams from "routing/useParams";
import useFetchView from "views/hooks/useFetchView";
import SearchPage from "./SearchPage";
const ShowViewPage = ({ children = void 0 }) => {
  const { viewId } = useParams();
  if (!viewId) {
    throw new Error("No view id specified!");
  }
  const view = useFetchView(viewId);
  return /* @__PURE__ */ React.createElement(SearchPage, { view, isNew: false }, children);
};
export default ShowViewPage;
